<!-- Единое содержимое заголовка секции: иконка, название и круглый счётчик. Раскрытием управляет родитель. -->
<template>
  <span class="base-section-header">
    <AppIcon v-if="icon" :name="icon" :size="18" class="base-section-header__icon" />
    <span class="base-section-header__title"><slot>{{ title }}</slot></span>
    <span v-if="count !== null" class="base-section-header__count" :aria-label="`Количество: ${count}`">{{ count }}</span>
  </span>
</template>
<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "BaseSectionHeader",
  components: { AppIcon },
  props: {
    title: { type: String, default: "" },
    icon: { type: String, default: null },
    count: { type: Number, default: null },
  },
};
</script>
<style scoped>
.base-section-header {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  gap: 6px;
  font-size: inherit;
  font-weight: inherit;
  line-height: 1.3;
}
.base-section-header__icon { flex-shrink: 0; }
.base-section-header__title { min-width: 0; overflow-wrap: anywhere; }
.base-section-header__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 24px;
  min-height: 24px;
  aspect-ratio: 1;
  padding: 3px;
  box-sizing: border-box;
  border-radius: 50%;
  background: #edf0f3;
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
}
</style>
